import axios from '@/requests';
import { Project } from '@/store/modules/project/types';

export interface CreateProjectForm {
    name: string,
    description: string,
    group: string,
}
export interface UpdateProjectForm {
    id: string,
    name: string,
    description: string,
    group: string,
}

export const projectAPI = {
    async getProjectList(): Promise<Project[]> {
        try {
            const res = await axios.get<Project[]>('/proj/listProject',)
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getOwnProjectList(): Promise<Project[]> {
        try {
            const res = await axios.get<Project[]>('/proj/listOwnProject',)
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async createProject(createProjectMsg: CreateProjectForm): Promise<Project> {
        try {
            const res = await axios.post<Project>('/proj/createProj', createProjectMsg)
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async deleteProject(id: string): Promise<Project> {
        try {
            const res = await axios.get<Project>('/proj/delProj', { "id": id })
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async updateProject(updateProjectMsg: UpdateProjectForm): Promise<Project> {
        try {
            const res = await axios.post<Project>('/proj/updateProj', updateProjectMsg)
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getProjectById(id: string): Promise<Project> {
        try {
            const res = await axios.get<Project>('/proj/getProjectById', { "id": id })
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },

}

